import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { ArrowLeft } from 'lucide-react'
import { ProductEditor } from '@/components/admin/product-editor'

export function AdminProductNewPage() {
  return (
    <>
      <Helmet>
        <title>New Product | Admin</title>
      </Helmet>
      <div className="space-y-4 sm:space-y-6">
        <Link to="/admin/products" className="inline-flex items-center text-muted-foreground hover:text-foreground">
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Products
        </Link>

        <div>
          <h1 className="text-2xl font-bold">New Product</h1>
          <p className="text-muted-foreground mt-1">
            Create a new product for your store
          </p>
        </div>

        <ProductEditor mode="create" />
      </div>
    </>
  )
}
